export const customEventSender =
  <Event extends EventsMap, Key extends keyof Event = keyof Event>(eventName: string) =>
  (key: Key, value: Event[Key]) => {
    const dataObj = {key, value};
    const storeEvent = new CustomEvent(eventName, {detail: dataObj});
    setTimeout(() => document.dispatchEvent(storeEvent), 0); // dispatch in next event loop
  };

type EventsMap = Record<string, unknown>;
